import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {requestGetUserEmailList, requestSaveUserEmail} from "@app/services/UserService";
import {alertMessage} from "@app/constants/Messages";
import {cloneDeep} from "lodash";
import Button from "react-bootstrap/Button";

const UserEmailListTable = (props) => {
    const [userEmails, setUserEmails] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [isMyself, setIsMyself] = useState(false)
    const {userId, myself, onClose} = props

    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(async () => {
        const strUserLogin = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)
        if (!userLoginInfo.id && strUserLogin) {
            const userLogin = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(userLogin)
            if (userId && !myself) {
                setIsMyself(userLogin.id === userId)
            }
        }

        if (myself) {
            setIsMyself(true)
        }

    }, [])

    const onSaveUserEmails = () => {
        setIsLoading(true)
        requestSaveUserEmail({user_emails: userEmails}).then((res) => {
            console.log(`Response-save user:${JSON.stringify(res)}`);
            alertMessage(res.sts_code)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const fetchUserEmails = async () => {
        console.log("fetchUserEmails")
        const res = await requestGetUserEmailList({user_id: userId});
        setUserEmails(res.content.user_emails)
    }


    useEffect(() => {
        fetchUserEmails()
    }, [userId]);

    const onChange = (event, index) => {
        userEmails[index][event.target.name] = event.target.value
        setUserEmails([...userEmails])
    }

    const onDelete = (index) => {
        let emailList = cloneDeep(userEmails)
        if (emailList.length === 1) {
            emailList = [];
        } else {
            emailList.splice(index, 1);
        }
        setUserEmails(emailList)
    };

    const onAddItem = () => {
        userEmails.push({
            email: "",
            app_email_password: "",
        })

        setUserEmails([...userEmails])
    }

    const onChangeItemIndex = (currIndex, newIndex) => {
        if (newIndex < 0 || newIndex > userEmails.length - 1) {
            return;
        }
        const item = userEmails[currIndex];
        userEmails.splice(currIndex, 1);
        userEmails.splice(newIndex, 0, item);

        setUserEmails([...userEmails])

    }


    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title"><b>{'Danh sách emails'}</b></h3>
                <div className={'card-tools'}>
                    {isMyself &&
                        <>
                            <button type={'button'} className={'btn btn-success float-right'}
                                    onClick={() => onAddItem()}>Add</button>
                            <Button type='button'
                                    className='btn btn-primary mr-2'
                                    isLoading={isLoading}
                                    disabled={
                                        isLoading
                                    }
                                    onClick={() => {
                                        onSaveUserEmails()
                                    }}
                            >
                                Save
                            </Button>
                        </>
                    }
                </div>
            </div>

            <div className='card-body table-responsive p-0 w-100'>
                <table
                    className='table table-hover table-bordered text-nowrap text-center'
                    style={{
                        maxHeight: '80vh',
                        overflow: 'scroll',
                        minHeight: 300
                    }}
                >
                    <thead>
                    <tr>
                        <th>STT</th>
                        <th>Email</th>
                        <th>Email app password</th>
                        {/*<th>Hạn mức gửi đi hiện tại</th>*/}
                        {isMyself &&
                        <th>Hành động</th>
                        }
                    </tr>
                    </thead>
                    <tbody>
                    {userEmails.map((item, index) => {
                        return <tr key={`user_emails_${index}`}>
                            <td>{index+1}</td>
                            <td>
                                {isMyself ?
                                    <input type='email' className='form-control'
                                           value={item.email ? item.email : ''}
                                           name={'email'}
                                           onChange={event => onChange(event, index)}/> : item.email
                                }
                            </td>
                            <td>
                                {isMyself ?
                                    <input type='password' className='form-control'
                                           value={item.app_email_password ? item.app_email_password : ''}
                                           name={'app_email_password'}
                                           onChange={event => onChange(event, index)}/> : item.app_email_password}
                            </td>
                            {/*<td>{item.limit_send_times_in_day}</td>*/}

                            {isMyself &&
                            <td>
                                {index > 0 &&
                                <button className='btn btn-default btn-sm' type='button'
                                        onClick={() => onChangeItemIndex(index, index - 1)}>
                                    Up
                                </button>
                                }
                                {index < userEmails.length - 1 &&
                                <button className='btn btn-default btn-sm ml-2' type='button'
                                        onClick={() => onChangeItemIndex(index, index + 1)}>
                                    Down
                                </button>
                                }
                                <button className='btn btn-danger ml-2'
                                        type='button'
                                        onClick={() => onDelete(index)}>
                                    Xóa
                                </button>
                            </td>}
                        </tr>
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UserEmailListTable;
